import React, {  useRef, useEffect } from 'react';
import Chart from 'chart.js/auto';
import stateAbbreviationToName from '../utils/StateAbbreviationToName'; 

/*
const PlotMultipleCurves = (cr, c1, c2, c3, c4,c5,c6, dp, lineType) => {

  const { xvals: unservedFiberXvals, yvals: unservedFiberYvals } = c1;
  const { xvals: unservedWirelessXvals, yvals: unservedWirelessYvals } = c2;
  const { xvals: unservedSatXvals, yvals: unservedSatYvals } = c3;

  const { xvals: underservedFiberXvals, yvals: underservedFiberYvals } = c3;
  const { xvals: underservedWirelessXvals, yvals: underservedWirelessYvals } = c4;
  const { xvals: underservedSatXvals, yvals: underservedSatYvals } = c5

  //const Xvals = [...new Set([...unservedFiberXvals, ...unservedWirelessXvals, ...unservedSatXvals, ...underservedFiberXvals, ...underservedWirelessXvals, ...underservedSatXvals])];
  const Xvals = [...new Set([...unservedFiberXvals, ...unservedWirelessXvals, ...unservedSatXvals])];


  const unservedFiberYvalsMillions = unservedFiberYvals.map((y) => y / 1000000);
  const unservedWirelessYvalsMillions = unservedWirelessYvals.map((y) => y / 1000000);
  const unservedSatYvalsMillions = unservedSatYvals.map((y) => y / 1000000);

  const underservedFiberYvalsMillions = underservedFiberYvals.map((y) => y / 1000000);
  const underservedWirelessYvalsMillions = underservedWirelessYvals.map((y) => y / 1000000);
  const underservedSatYvalsMillions = underservedSatYvals.map((y) => y / 1000000);


  const unservedFiberData = unservedFiberXvals.map((x, index) => ({
    x: x,
    y: unservedFiberYvalsMillions[index],
  }));
  const unservedWirelessData = unservedWirelessXvals.map((x, index) => ({
    x: x,
    y: unservedWirelessYvalsMillions[index],
  }));
  const unservedSatelliteData = unservedSatXvals.map((x, index) => ({
    x: x,
    y: unservedSatYvalsMillions[index],
  }));

  
  const underservedFiberData = underservedFiberXvals.map((x, index) => ({
    x: x,
    y: underservedFiberYvalsMillions[index],
  }));
  const underservedWirelessData = underservedWirelessXvals.map((x, index) => ({
    x: x,
    y: underservedWirelessYvalsMillions[index],
  }));
  const underservedSatelliteData = underservedSatXvals.map((x, index) => ({
    x: x,
    y: underservedSatYvalsMillions[index],
  }));


  const unservedCombinedData = Xvals.map((x) => ({
    x: x,
    yFiber: unservedFiberData.find((d) => d.x === x)?.y || null,
    yWireless: unservedWirelessData.find((d) => d.x === x)?.y || null,

   
  }));

  const underservedCombinedData = Xvals.map((x) => ({
    x: x,
    yFiber: underservedFiberData.find((d) => d.x === x)?.y || null,
    yWireless: underservedWirelessData.find((d) => d.x === x)?.y || null,
   
  }));


  const fundDepletionData = dp
    ? [{
    x: dp.x,
    y: dp.y / 1000000,
    }]
  : [];

  cr.current = new Chart('fibreGraph', {
    type: 'line',
    data: {
      
      datasets: [
        {
          label: 'Fund Depletion',
          data: fundDepletionData,
          backgroundColor: 'red',
          borderColor: 'red',
          pointRadius: 5, 
        },
        {
          label: 'Unserved Fiber',
          data: unservedCombinedData.map((d) => ({ x: d.x, y: d.yFiber })),
          backgroundColor: '#42a5f5',
          borderColor: '#42a5f5',
          fill: false,
          pointRadius: 0,
        },
        {
          label: 'Unserved Wireless',
          data: unservedCombinedData.map((d) => ({ x: d.x, y: d.yWireless })),
          backgroundColor: '#7e57c2',
          borderColor: '#7e57c2',
          fill: false,
          pointRadius: 0,
        },
        {
          label: 'Unserved Satellite',
          data: unservedSatelliteData,
          backgroundColor: 'orange', 
          borderColor: 'orange', 
          fill: false,
          pointRadius: 0,
        },
      
       
      ],
    },

    options: {
      responsive: true,
      scales: {
        x: {
          title: {
            display: true,
            text: 'Percent of Unserved and Underserved Locations Served',
            color: '#9e9e9e',
          },
          ticks: {
            color: '#9e9e9e', 
          },
        },
        y: {
          title: {
            display: true,
            text: 'Total Cost ($ Millions)',
            color: '#9e9e9e',
          },
          ticks: {
            color: '#9e9e9e', 
          },
        },
      },
      plugins: {
        legend: {
          labels: {
            color: '#9e9e9e', 
          },
        },
      },
    },
  });
}
*/

const PlotMultipleCurves = (cr, c1, c2, c3, c4,c5,c6, dp1, dp2) => {

  const { xvals: unservedFiberXvals, yvals: unservedFiberYvals } = c1;
  const { xvals: unservedWirelessXvals, yvals: unservedWirelessYvals } = c2;
  const { xvals: unservedSatXvals, yvals: unservedSatYvals } = c3;
  const { xvals: underservedFiberXvals, yvals: underservedFiberYvals } = c4;
  const { xvals: underservedWirelessXvals, yvals: underservedWirelessYvals } = c5;
  const { xvals: underservedSatXvals, yvals: underservedSatYvals } = c6

  // console.log(underservedFiberYvals)

  const unservedXvals = [...new Set([...unservedFiberXvals, ...unservedWirelessXvals, ...unservedSatXvals])];
  const underservedXvals = [...new Set([...underservedFiberXvals, ...underservedWirelessXvals, ...underservedSatXvals])];
  const unservedFiberYvalsMillions = unservedFiberYvals.map((y) => y / 1000000);
  const unservedWirelessYvalsMillions = unservedWirelessYvals.map((y) => y / 1000000);
  const unservedSatYvalsMillions = unservedSatYvals.map((y) => y / 1000000);
  const underservedFiberYvalsMillions = underservedFiberYvals.map((y) => y / 1000000);
  const underservedWirelessYvalsMillions = underservedWirelessYvals.map((y) => y / 1000000);
  const underservedSatYvalsMillions = underservedSatYvals.map((y) => y / 1000000);


  const unservedFiberData = unservedFiberXvals.map((x, index) => ({
    x: x,
    y: unservedFiberYvalsMillions[index],
  }));
  const unservedWirelessData = unservedWirelessXvals.map((x, index) => ({
    x: x,
    y: unservedWirelessYvalsMillions[index],
  }));
  const unservedSatelliteData = unservedSatXvals.map((x, index) => ({
    x: x,
    y: unservedSatYvalsMillions[index],
  }));

  
  const underservedFiberData = underservedFiberXvals.map((x, index) => ({
    x: x,
    y: underservedFiberYvalsMillions[index],
  }));
  const underservedWirelessData = underservedWirelessXvals.map((x, index) => ({
    x: x,
    y: underservedWirelessYvalsMillions[index],
  }));
  const underservedSatelliteData = underservedSatXvals.map((x, index) => ({
    x: x,
    y: underservedSatYvalsMillions[index],
  }));


  const unservedCombinedData = unservedXvals.map((x) => ({
    x: x,
    yFiber: unservedFiberData.find((d) => d.x === x)?.y || null,
    yWireless: unservedWirelessData.find((d) => d.x === x)?.y || null,

   
  }));

  const underservedCombinedData = underservedXvals.map((x) => ({
    x: x,
    yFiber: underservedFiberData.find((d) => d.x === x)?.y || null,
    yWireless: underservedWirelessData.find((d) => d.x === x)?.y || null,
   
  }));




  const unservedfundDepletionData = dp1
    ? [{
    x: dp1.x,
    y: dp1.y / 1000000,
    }]
  : [];

  const underservedfundDepletionData = dp2
    ? [{
    x: dp2.x,
    y: dp2.y / 1000000,
    }]
  : [];


  cr.current = new Chart('fibreGraph', {
    type: 'scatter',
    data: {

      datasets: [
        {
          label: 'Cost to Serve (Unserved)',
          data: unservedfundDepletionData,
          backgroundColor: 'red',
          borderColor: 'red',
          pointRadius: 5, 
        },

        {
          label: 'Cost to Serve (Underserved)',
          data: underservedfundDepletionData,
          backgroundColor: 'pink',
          borderColor: 'pink',
          pointRadius: 5, 
        },


        {
          label: 'Unserved Fiber',
          data: unservedCombinedData.map((d) => ({ x: d.x, y: d.yFiber })),
          backgroundColor: '#42a5f5',
          borderColor: '#42a5f5',
        },
        {
          label: 'Unserved Wireless',
          data: unservedCombinedData.map((d) => ({ x: d.x, y: d.yWireless })),
          backgroundColor: '#7e57c2',
          borderColor: '#7e57c2',
        },
        {
          label: 'Unserved Satellite',
          data: unservedSatelliteData,
          backgroundColor: 'orange', 
          borderColor: 'orange', 
          
        },
        {
          label: 'Underserved Fiber',
          data: underservedCombinedData.map((d) => ({ x: d.x, y: d.yFiber })),
          backgroundColor: 'green',
          borderColor: 'green',
        },
        {
          label: 'Underserved Wireless ',
          data: underservedCombinedData.map((d) => ({ x: d.x, y: d.yWireless })),
          backgroundColor: 'yellow',
          borderColor: 'yellow',
        },
        {
          label: 'Underserved Satellite',
          data: underservedSatelliteData,
          backgroundColor: 'white',
          borderColor: 'white',
        },
      ],
    },

    options: {
      elements: {
        point: {
          radius: 2,
          pointStyle: 'circle'
        }
      },
      responsive: true,
      scales: {
        x: {
          title: {
            display: true,
            text: 'Percent of Unserved and Underserved Locations Served',
            color: '#9e9e9e',
          },
          ticks: {
            color: '#9e9e9e', 
          },
        },
        y: {
          title: {
            display: true,
            text: 'Total Cost ($ Millions)',
            color: '#9e9e9e',
          },
          ticks: {
            color: '#9e9e9e', 
          },
        },
      },
      plugins: {
        legend: {
          labels: {
            color: '#9e9e9e',
          },
        },
        tooltip: {
          callbacks: {
            title: function(tooltipItems) {
              let xValue = tooltipItems[0].raw.x;
              xValue = Math.round(xValue);
              return `${xValue}% served`;
            },
            label: function(context) {
              let yValue = context.raw.y;
              let formattedYValue = new Intl.NumberFormat('en-US', {
                style: 'decimal',
                maximumFractionDigits: 0,
                minimumFractionDigits: 0
              }).format(yValue);

              return `$${formattedYValue} million`;
            }
          }
        }
      },
    },
  });
}




const LineGraph = ({ data, stateLoad, selectedState}) => {
  const chartRef = useRef(null);
  // console.log(selectedState)
  useEffect(() => {
    if (stateLoad) {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
      let chartData = {};
      let chartOptions = {};
      if ( selectedState === 'UNKNOWN') {

        chartData = {
          labels: [],
          datasets: [],
        };
        chartOptions = {
        };
      } else {
        // console.log(data.unserved_locations_not_connected.perc, data.underserved_locations_not_connected.perc )
        if (data.unserved_locations_fiber.perc === 100.0 && data.underserved_locations_fiber.perc === 100.0) {
          // Only render fiber graph
          if (chartRef.current) {
            chartRef.current.destroy();
          }
          const {xvals: fiberXvals, yvals: fiberYvals} = data.fiber_graph;
          const xvals = [...new Set([...fiberXvals])];
          const fiberYvalsMillions = fiberYvals.map((y) => y / 1000000);
          const fiberData = fiberXvals.map((x, index) => ({
            x: x,
            y: fiberYvalsMillions[index],
          }));
          const combinedData = xvals.map((x) => ({
            x: x,
            yFiber: fiberData.find((d) => d.x === x)?.y || null

          }));

          const fundDepletionData = data["fund_depleation_point"]
              ? [{
                x: data["fund_depleation_point"].x,
                y: data["fund_depleation_point"].y / 1000000,
              }]
              : [];

          chartRef.current = new Chart('fibreGraph', {
            type: 'scatter',
            data: {
              labels: xvals,
              datasets: [
                {
                  label: 'Cost to Serve',
                  data: fundDepletionData,
                  backgroundColor: 'red',
                  borderColor: 'red',
                  pointRadius: 5,
                },
                {
                  label: 'Fiber Costs',
                  data: combinedData.map((d) => ({x: d.x, y: d.yFiber})),

                  backgroundColor: '#42a5f5',
                  borderColor: '#42a5f5',
                  fill: false,
                  pointRadius: 2,
                },
              ],
            },
            options: {
              responsive: true,
              scales: {
                x: {
                  title: {
                    display: true,
                    text: 'Percent of Unserved and Underserved Locations Served',
                    color: '#9e9e9e',
                  },
                  ticks: {
                    color: '#9e9e9e',
                  },
                },
                y: {
                  title: {
                    display: true,
                    text: 'Total Cost ($ Millions)',
                    color: '#9e9e9e',
                  },
                  ticks: {
                    color: '#9e9e9e',
                  },
                },
              },
              plugins: {
                legend: {
                  labels: {
                    color: '#9e9e9e',
                  },
                },
                tooltip: {
                  callbacks: {
                    title: function(tooltipItems) {
                      let xValue = tooltipItems[0].raw.x;
                      xValue = Math.round(xValue);
                      return `${xValue}% served`;
                    },
                    label: function(context) {
                      let yValue = context.raw.y;
                      let formattedYValue = new Intl.NumberFormat('en-US', {
                        style: 'decimal',
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0
                      }).format(yValue);

                      return `$${formattedYValue} million`;
                    }
                  }
                }
              },
            },
          });

        } else if (data && data.multi_graphs) {

          if (chartRef.current) {
            chartRef.current.destroy();
          }
          if (data.reached_underserved === false) {
            PlotMultipleCurves(chartRef, data.fiber_graph_unserved, data.fixed_wireless_graph_unserved, data.satellite_graph_unserved, data.fiber_graph_underserved, data.fixed_wireless_graph_underserved, data.satellite_graph_underserved, data.unserved_cost_to_serve, data.underserved_cost_to_serve)
          }
          else{
          // console.log(data.fiber_graph_unserved, data.fixed_wireless_graph_unserved, data.satellite_graph_unserved)
              PlotMultipleCurves(chartRef, data.fiber_graph_unserved, data.fixed_wireless_graph_unserved, data.satellite_graph_unserved, data.fiber_graph_underserved, data.fixed_wireless_graph_underserved, data.satellite_graph_underserved, data.unserved_cost_to_serve, data.underserved_cost_to_serve)
            }
        } else if (data && data.fiber_graph && data.fixed_wirless_intersection_graph && data.satellite_intersection_graph) {
          if (chartRef.current) {
            chartRef.current.destroy();
          }
          // console.log(data)

          const {xvals: fiberXvals, yvals: fiberYvals} = data.fiber_graph;
          const {xvals: wirelessXvals, yvals: wirelessYvals} = data.fixed_wirless_intersection_graph;
          const {xvals: satXvals, yvals: satYvals} = data.satellite_intersection_graph;
          const xvals = [...new Set([...fiberXvals, ...wirelessXvals, ...satXvals])];
          const fiberYvalsMillions = fiberYvals.map((y) => y / 1000000);
          const wirelessYvalsMillions = wirelessYvals.map((y) => y / 1000000);
          const satYvalsMillions = satYvals.map((y) => y / 1000000);
          const fiberData = fiberXvals.map((x, index) => ({
            x: x,
            y: fiberYvalsMillions[index],
          }));
          const wirelessData = wirelessXvals.map((x, index) => ({
            x: x,
            y: wirelessYvalsMillions[index],
          }));
          const satelliteData = satXvals.map((x, index) => ({
            x: x,
            y: satYvalsMillions[index],
          }));
          const shouldRenderSatelliteGraph = !(satelliteData.length === 1 && satelliteData[0].y === 0);


          const combinedData = xvals.map((x) => ({
            x: x,
            yFiber: fiberData.find((d) => d.x === x)?.y || null,
            yWireless: wirelessData.find((d) => d.x === x)?.y || null,
          }));

          const fundDepletionData = data["fund_depleation_point"]
              ? [{
                x: data["fund_depleation_point"].x,
                y: data["fund_depleation_point"].y / 1000000,
              }]
              : [];
          const graph_datasets = [
            {
              label: 'Cost to Serve',
              data: fundDepletionData,
              backgroundColor: 'red',
              borderColor: 'red',
              pointRadius: 5,
            },
            {
              label: 'Fiber Costs',
              borderDash: [10, 5],
              data: combinedData.map((d) => ({x: d.x, y: d.yFiber})),
              backgroundColor: '#42a5f5',
              borderColor: '#42a5f5',
              //fill: false,
              pointRadius: 2,
            },
            {
              label: 'Wireless Costs',
              data: combinedData.map((d) => ({x: d.x, y: d.yWireless})),
              backgroundColor: '#7e57c2',
              borderColor: '#7e57c2',
              //fill: false,
              pointRadius: 2,
            },
            // {
            //   label: 'Satellite Costs',
            //   data: satelliteData,
            //   backgroundColor: 'orange',
            //   borderColor: 'orange',
            //   //fill: false,
            //   pointRadius: 2,
            // },
          ];
          if (shouldRenderSatelliteGraph) {
            graph_datasets.push({
              label: 'Satellite Costs',
              data: satelliteData,
              backgroundColor: 'orange',
              borderColor: 'orange',
              pointRadius: 2,
            });
          }
          chartRef.current = new Chart('fibreGraph', {
            type: 'scatter',
            data: {
              labels: xvals,
              datasets: graph_datasets
            },
            options: {
              responsive: true,
              scales: {
                x: {
                  title: {
                    display: true,
                    text: 'Percent of Unserved and Underserved Locations Served',
                    color: '#9e9e9e',
                  },
                  ticks: {
                    color: '#9e9e9e',
                  },
                },
                y: {
                  title: {
                    display: true,
                    text: 'Total Cost ($ Millions)',
                    color: '#9e9e9e',
                  },
                  ticks: {
                    color: '#9e9e9e',
                  },
                },
              },
              plugins: {
                legend: {
                  labels: {
                    color: '#9e9e9e',
                  },
                },
                tooltip: {
                  callbacks: {
                    title: function(tooltipItems) {
                      let xValue = tooltipItems[0].raw.x;
                      xValue = Math.round(xValue);
                      return `${xValue}% served`;
                    },
                    label: function(context) {
                      let yValue = context.raw.y;
                      let formattedYValue = new Intl.NumberFormat('en-US', {
                        style: 'decimal',
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0
                      }).format(yValue);

                      return `$${formattedYValue} million`;
                    }
                  }
                }
                ,
              },
            },
          });
        }

      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data /*, stateLoad */]);

  return (
    <div style={{ textAlign: 'center'}}>
      <h2 style={{ fontSize: '14px' }}>
        Total Costs for {stateAbbreviationToName(selectedState)} to Connect Unserved and Underserved Locations
      </h2>
      <canvas id="fibreGraph" width={0} height={600}></canvas>
    </div>
  );
};

export default LineGraph;
